import React, { useState } from 'react';
import { cn } from '../cn';
import { accentStyle } from './accents';
import { DASHBOARD_PERIODS, validateDashboardCustomPeriod } from './periods';
/**
 * Today / 7d / 30d / Custom — same presets as transaction ledgers.
 * Custom only commits via Apply (never fires onChange with empty dates).
 */
export const PeriodPicker = ({ value, dateFrom = '', dateTo = '', onChange, disabled, accent = 'orange', className, }) => {
    const a = accentStyle(accent);
    const [draftFrom, setDraftFrom] = useState(dateFrom);
    const [draftTo, setDraftTo] = useState(dateTo);
    const [customError, setCustomError] = useState(null);
    /** Local UI: show custom inputs before parent has committed period=custom. */
    const [customDraftOpen, setCustomDraftOpen] = useState(false);
    React.useEffect(() => {
        setDraftFrom(dateFrom);
        setDraftTo(dateTo);
        if (value === 'custom')
            setCustomDraftOpen(false);
    }, [dateFrom, dateTo, value]);
    const showCustomUi = value === 'custom' || customDraftOpen;
    const activePreset = showCustomUi ? 'custom' : value;
    const selectPreset = (period) => {
        setCustomError(null);
        if (period === 'custom') {
            setCustomDraftOpen(true);
            return;
        }
        setCustomDraftOpen(false);
        onChange({ period });
    };
    const applyCustom = () => {
        const err = validateDashboardCustomPeriod(draftFrom, draftTo);
        if (err) {
            setCustomError(err);
            return;
        }
        setCustomError(null);
        setCustomDraftOpen(false);
        onChange({ period: 'custom', dateFrom: draftFrom.trim(), dateTo: draftTo.trim() });
    };
    return (React.createElement("div", { className: cn('inline-flex flex-wrap items-center gap-2', className) },
        React.createElement("div", { className: cn('inline-flex rounded-xl border p-1', a.segmentContainer) }, DASHBOARD_PERIODS.map((preset) => (React.createElement("button", { key: preset.value, type: "button", disabled: disabled, onClick: () => selectPreset(preset.value), className: cn('rounded-lg px-3 py-1.5 text-sm font-medium transition-colors disabled:opacity-60', activePreset === preset.value ? a.segmentActive : a.segmentInactive) }, preset.label)))),
        showCustomUi ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "flex items-center gap-1.5" },
                React.createElement("label", { htmlFor: "dashboard-period-from", className: "shrink-0 text-xs font-medium text-gray-600" }, "From"),
                React.createElement("input", { id: "dashboard-period-from", type: "date", disabled: disabled, value: draftFrom, onChange: (e) => {
                        setDraftFrom(e.target.value);
                        setCustomError(null);
                    }, className: cn('h-9 w-[9.5rem] rounded-lg border border-gray-200 bg-white px-3 text-sm outline-none focus:ring-2 disabled:opacity-60', a.periodFocus) })),
            React.createElement("div", { className: "flex items-center gap-1.5" },
                React.createElement("label", { htmlFor: "dashboard-period-to", className: "shrink-0 text-xs font-medium text-gray-600" }, "To"),
                React.createElement("input", { id: "dashboard-period-to", type: "date", disabled: disabled, value: draftTo, onChange: (e) => {
                        setDraftTo(e.target.value);
                        setCustomError(null);
                    }, className: cn('h-9 w-[9.5rem] rounded-lg border border-gray-200 bg-white px-3 text-sm outline-none focus:ring-2 disabled:opacity-60', a.periodFocus) })),
            React.createElement("button", { type: "button", disabled: disabled, onClick: applyCustom, className: cn('rounded-lg px-3 py-1.5 text-sm font-medium text-white transition-colors disabled:opacity-60', a.periodApply) }, "Apply"))) : null,
        customError ? React.createElement("p", { className: "w-full text-xs text-red-600" }, customError) : null));
};
export default PeriodPicker;
